module.exports = __webpack_public_path__ + "e14.no2.12769bf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e14.no2.jpg
// module id = KS85
// module chunks = 0